import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  templateUrl: "./shortcuts-modal.component.html",
})
export class ShortcutsModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
